import { useEffect } from "react";

export default function useDocTitle(title, skip = false, domain = "Regenerus") {
  useEffect(() => {
    if (skip) return;
    document.title = `${title} | ${domain}`;
    // eslint-disable-next-line
  }, [title, skip]);
}
